import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onedaypicnicspot() {



    const cardData =
    {
        keyword: 'One Day Picnic Spot Near Pune at Morachi Chincholi',
        heading: 'Anand Krushi Paryatan Kendra: One Day Picnic Spot Near Pune at Morachi Chincholi',
        headingDescription: 'If you are looking for a peaceful yet activity-filled one day picnic spot near Pune, Anand Krushi Paryatan Kendra in Morachi Chincholi offers the perfect countryside escape. Just 60 km from Pune, this eco-tourism destination blends natural beauty, rural experiences, and family-friendly fun all in one place. Nestled in the scenic village of Morachi Chincholi—famous for its free-roaming peacocks—Anand Krushi Paryatan Kendra invites guests to reconnect with nature through bullock cart rides, peacock watching, traditional Maharashtrian meals, and agri-tour walks. Ideal for families, school groups, and corporate teams, this one-day picnic spot near Pune promises an unforgettable blend of adventure and rural hospitality. Whether you are planning a weekend getaway or a group day-outing, Anand Krushi Paryatan Kendra ensures a refreshing experience close to the city.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

        topPlaces: [
            {
                "title": "Peacock & Bird Watching",
                "description": "Morachi Chincholi is renowned as a natural peacock sanctuary, where visitors can witness these majestic birds roaming freely in their natural habitat. Early mornings and evenings are ideal for birdwatching walks that also reveal a variety of native species, creating a peaceful and photogenic nature experience."
            },
            {
                "title": "Water Park, Swimming & Rain Dance",
                "description": "The on-site water park offers refreshing fun with a large swimming pool, rain dance zone, and mini water slides. Families and children can cool off in the summer heat while enjoying lively music and safe water play in a scenic rural setting."
            },
            {
                "title": "Bullock Cart & Tractor Rides",
                "description": "Enjoy traditional bullock cart rides and tractor safaris through the lush farmlands and scenic village roads. These rural rides provide a charming glimpse into agrarian life and are especially fun for children and first-time rural explorers."
            },
            {
                "title": "Adventure & Outdoor Games",
                "description": "Get your adrenaline pumping with activities like zip-lining, archery, rope balancing, and team games such as cricket, volleyball, and badminton. The open grounds and fresh countryside air add to the thrill and excitement of outdoor fun."
            },
            {
                "title": "Traditional Village Games",
                "description": "Relive childhood memories with classic village games like lagori, gilli-danda, and tug-of-war. These nostalgic activities are perfect for family bonding and are often guided by local hosts who explain their cultural significance."
            },
            {
                "title": "Magic Show, Puppet Show & DJ Music",
                "description": "Live entertainment includes interactive magic shows, colorful puppet performances, and DJ-led rain dance sessions. These attractions add an element of joy and celebration, especially on weekends and holidays."
            },
            {
                "title": "Nature Trails & Farm Walks",
                "description": "Stroll through well-maintained farm trails surrounded by banana plantations, sugarcane fields, and seasonal flowers. Guided nature walks introduce visitors to organic farming practices and the biodiversity of the region."
            },
            {
                "title": "Authentic Maharashtrian Meals",
                "description": "Savor unlimited traditional Maharashtrian meals cooked with love using fresh, locally sourced ingredients. The typical menu includes poha, puran poli, zunka bhakri, seasonal vegetables, chutneys, and refreshing beverages like buttermilk and sugarcane juice."
            },
            {
                "title": "Children’s Play Zone & Trampoline Fun",
                "description": "Kids can spend hours in the designated play area featuring swings, slides, see-saws, trampolines, and other child-safe structures. The environment is clean, green, and perfectly suited for worry-free family outings."
            },
            {
                "title": "Evening Bonfire & Camping Experience",
                "description": "For those opting to extend their visit, the resort offers a peaceful camping option with evening bonfires, group games, and stargazing. It's a great way to disconnect from the city and enjoy rural serenity overnight."
            }
        ],




        "services": [
            {
                "name": "Best Picnic Spots Near Pune for One Day",
                "description": "Anand Krushi Paryatan Kendra offers one of the best picnic experiences near Pune. Surrounded by nature and packed with rural charm, it's ideal for families and friends looking for a peaceful one-day retreat filled with farm fun and delicious local food."
            },
            {
                "name": "Morachi Chincholi Picnic Ideas",
                "description": "Looking for unique picnic ideas near Morachi Chincholi? Anand Krushi Paryatan Kendra provides a perfect mix of traditional rural experiences and modern comfort, including bullock cart rides, nature trails, and authentic Maharashtrian meals."
            },
            {
                "name": "Family Picnic Spots Near Pune",
                "description": "Anand Krushi Paryatan Kendra is a family-friendly picnic spot near Pune, offering safe, engaging, and educational experiences for all age groups through hands-on farm activities and spacious play areas for kids."
            },
            {
                "name": "Romantic Picnic Destinations Near Morachi Chincholi",
                "description": "Escape the city and enjoy a romantic day at Anand Krushi Paryatan Kendra, a serene and scenic location near Morachi Chincholi. Enjoy a peaceful environment, nature walks, and a cozy meal under the open sky with your partner."
            },
            {
                "name": "Scenic Day Picnic Near Pune",
                "description": "Anand Krushi Paryatan Kendra is nestled in the countryside, making it a picturesque location for a scenic day picnic near Pune. Relax amid greenery, explore the farm, and enjoy a refreshing change from city life."
            },
            {
                "name": "Budget-Friendly Picnic Places Near Morachi Chincholi",
                "description": "Enjoy a full day of fun and relaxation without breaking the bank at Anand Krushi Paryatan Kendra. It’s a budget-friendly picnic spot near Morachi Chincholi offering authentic rural experiences at great value."
            },
            {
                "name": "Picnic Spots with Outdoor Activities Near Pune",
                "description": "Anand Krushi Paryatan Kendra is perfect for those who enjoy outdoor activities like nature walks, farming demos, and traditional games. It's a wholesome picnic destination near Pune for all age groups."
            },
            {
                "name": "Pet-Friendly Picnic Locations Near Morachi Chincholi",
                "description": "Looking for a pet-friendly picnic spot near Morachi Chincholi? Anand Krushi Paryatan Kendra welcomes your furry companions to enjoy open spaces and a farm environment alongside the whole family."
            },
            {
                "name": "Nature Picnic Spots Near Pune",
                "description": "Rejuvenate your senses at Anand Krushi Paryatan Kendra, a nature-rich picnic destination near Pune that offers lush landscapes, clean air, and immersive farming experiences close to Morachi Chincholi."
            },
            {
                "name": "One Day Picnic with Adventure Near Morachi Chincholi",
                "description": "For a one-day adventure, head to Anand Krushi Paryatan Kendra near Morachi Chincholi. Enjoy bullock cart rides, tractor tours, and hands-on farm activities in a rustic and exciting setting."
            },
            {
                "name": "Popular Picnic Destinations Near Pune for Couples",
                "description": "Anand Krushi Paryatan Kendra is a peaceful and romantic getaway near Pune, perfect for couples looking for a quiet spot to connect, enjoy a traditional meal, and spend quality time in a scenic farm environment."
            },
            {
                "name": "Day Picnic Spots with Farm Experience Near Morachi Chincholi",
                "description": "Immerse yourself in the farm lifestyle at Anand Krushi Paryatan Kendra. Learn about agriculture, feed animals, and enjoy fresh local food, making it a perfect day picnic spot near Morachi Chincholi."
            },
            {
                "name": "Peaceful Picnic Getaways Near Pune",
                "description": "Escape the hustle of Pune and spend a relaxing day at Anand Krushi Paryatan Kendra. Surrounded by greenery and the calming sights and sounds of nature, it’s an ideal peaceful picnic destination."
            },
            {
                "name": "Picnic Spots with Kids’ Play Area Near Morachi Chincholi",
                "description": "With a spacious play zone and interactive farm activities, Anand Krushi Paryatan Kendra is a fun-filled picnic destination for families with kids near Morachi Chincholi."
            },
            {
                "name": "Weekend Picnic Destinations Near Pune",
                "description": "Plan your weekend escape to Anand Krushi Paryatan Kendra, a relaxing farm retreat near Pune offering traditional rural fun, perfect for refreshing your mind and body."
            },
            {
                "name": "Hidden Picnic Gems Near Morachi Chincholi",
                "description": "Anand Krushi Paryatan Kendra is a hidden gem near Morachi Chincholi, offering a tranquil farm setting with local flavors, perfect for those looking for an offbeat picnic destination."
            },
            {
                "name": "Picnic Spots with Food Stalls Near Pune",
                "description": "Enjoy traditional, freshly prepared meals and snacks at Anand Krushi Paryatan Kendra, where the food is a big part of the farm picnic experience near Pune."
            }
        ],
        "tableData": [
            ["Best Picnic Spots Near Pune for One Day", "- Morachi Chincholi Picnic Ideas"],
            ["Family Picnic Spots Near Pune", "- Romantic Picnic Destinations Near Morachi Chincholi"],
            ["Scenic Day Picnic Near Pune", "- Budget-Friendly Picnic Places Near Morachi Chincholi"],
            ["Picnic Spots with Outdoor Activities Near Pune", "- Pet-Friendly Picnic Locations Near Morachi Chincholi"],
            ["Nature Picnic Spots Near Pune", "- One Day Picnic with Adventure Near Morachi Chincholi"],
            ["Popular Picnic Destinations Near Pune for Couples", "- Day Picnic Spots with Farm Experience Near Morachi Chincholi"],
            ["Peaceful Picnic Getaways Near Pune", "- Picnic Spots with Kids’ Play Area Near Morachi Chincholi"],
            ["Weekend Picnic Destinations Near Pune", "- Hidden Picnic Gems Near Morachi Chincholi"],
            ["Picnic Spots with Food Stalls Near Pune", "- "]
        ],



        "whychoose": [
            {
                "WhyChooseheading": "Just a Stone’s Throw from Pune",
                "WhyChoosedescription": "Located just around 55 km from Pune, Anand Krushi Paryatan Kendra in Morachi Chincholi is a perfect one-day escape into nature. The short and scenic drive through lush countryside makes it ideal for families, friends, school trips, or corporate outings. No need to plan a long vacation—just hop in your car and arrive in under two hours!"
            },
            {
                "WhyChooseheading": "Peacock Sanctuary & Birdwatching",
                "WhyChoosedescription": "Morachi Chincholi is renowned for its thriving population of more than 2,500 peacocks living freely in the natural habitat of historic tamarind groves. Anand Krushi Paryatan Kendra offers guided birdwatching walks during early mornings and evenings, where you can witness these majestic birds dancing and calling—a breathtaking experience for nature and photography lovers."
            },
            {
                "WhyChooseheading": "Authentic Rural Agritourism Experience",
                "WhyChoosedescription": "Experience the charm of rural Maharashtra with bullock cart rides, tractor rides, farm tours, and interactive sessions with local farmers. Learn about organic farming, irrigation methods, and seasonal crops. The center promotes hands-on experiences like ploughing, vegetable picking, and feeding livestock, making it an educational and fun trip for all ages."
            },
            {
                "WhyChooseheading": "Fun-Filled Activities for Kids and Families",
                "WhyChoosedescription": "Children can enjoy puppet shows, magic shows, trampoline fun, and play areas designed for safe and engaging entertainment. Families can participate together in traditional games like gilli-danda and lagori. The interactive animal zone, where kids can pet and feed goats, rabbits, and ducks, adds a wholesome touch to your family day out."
            },
            {
                "WhyChooseheading": "Adventure & Outdoor Entertainment",
                "WhyChoosedescription": "Adventure lovers can try zip-lining, archery, rope climbing, and boating in the nearby lake. Groups can join in team games like cricket, volleyball, tug-of-war, and obstacle courses. A rain dance arena with music adds a splash of excitement to summer days. With vast open grounds and fresh air, outdoor fun is unlimited here."
            },
            {
                "WhyChooseheading": "Seasonal Events and Cultural Experiences",
                "WhyChoosedescription": "Anand Krushi Paryatan Kendra hosts seasonal festivals like Hurda Parties in winter, where you enjoy freshly roasted green jowar with jaggery, chutney, and buttermilk. In summer, the Mango Festival delights visitors with naturally ripened Alphonso and Kesar mangoes from local farms. Guests also enjoy folk music, lantern festivals, and traditional village dinners under the stars."
            },
            {
                "WhyChooseheading": "Camping, Bonfires & Stargazing",
                "WhyChoosedescription": "Extend your day trip into an overnight adventure with camping options that include cozy tents, bonfire evenings, and stargazing under clear skies. Rural silence, fresh air, and fireflies create a magical atmosphere that rejuvenates both body and mind. Perfect for couples, families, and groups looking for a peaceful retreat."
            },
            {
                "WhyChooseheading": "Affordable, All-Inclusive Picnic Packages",
                "WhyChoosedescription": "Anand Krushi Paryatan Kendra offers value-for-money packages starting at just ₹600 for adults and ₹300 for children, inclusive of welcome drinks, authentic Maharashtrian meals, access to all major activities, and rides. Customized corporate and school group packages are also available, offering meals, guided tours, games, and performance shows—all at an affordable price."
            }
        ]


    }

    const faqData = [
        {
            id: 'FAQ1',
            question: 'How far is Anand Krushi Paryatan Kendra from Pune?',
            answer: 'Located around 65 km from Pune, it’s a convenient drive of approximately 1.5 hours—perfect for a day outing.',
        },
        {
            id: 'FAQ2',
            question: 'What are the entry fees and timings?',
            answer: 'Open from 9 AM to 5 PM on weekends and holidays. Entry fee is ₹100–150 per person; pony and tractor rides cost extra.',
        },
        {
            id: 'FAQ3',
            question: 'What kind of farm activities are offered?',
            answer: 'Enjoy butterfly watching, pony rides, tractor rides, farm and bird walks, interactive farm chores, and casual games.',
        },
        {
            id: 'FAQ4',
            question: 'Is it family/kid-friendly?',
            answer: 'Absolutely! With play areas, pony rides, shaded paths, and gentle farm activities, it’s ideal for all ages.',
        },
        {
            id: 'FAQ5',
            question: 'Can schools or groups book educational outings?',
            answer: 'Yes—school and group bookings are welcome and can include guided nature tours and interactive sessions about farming.',
        },
        {
            id: 'FAQ6',
            question: 'Is food available on-site?',
            answer: 'There’s a snack counter selling light refreshments; packed meals are allowed and picnic seating is provided.',
        },
        {
            id: 'FAQ7',
            question: 'Are restrooms and changing facilities available?',
            answer: 'Yes, clean restrooms and basic changing areas are available near the main picnic zone.',
        },
        {
            id: 'FAQ8',
            question: 'Is parking available?',
            answer: 'Yes—ample free parking is provided for cars and two‑wheelers right at the venue entrance.',
        },
        {
            id: 'FAQ9',
            question: 'Do we need to book in advance?',
            answer: 'Advance booking is recommended for weekends and groups. Solo visitors can usually walk in.',
        },
        {
            id: 'FAQ10',
            question: 'Is Anand Krushi pet-friendly?',
            answer: 'Pets are not allowed inside the main activity areas for safety and hygiene, but service animals with proper documentation may be permitted.',
        },
    ];

    const testimonials = [
        {
            id: 1,
            name: 'Mr. Amit Deshpande, Pune',
            feedback: "Our family had a fantastic day at Anand Krushi! The pony rides and tractor rides were the highlights. Our daughter loved the butterfly walk—truly a wholesome experience.",
            rating: 5,
        },
        {
            id: 2,
            name: 'Ms. Neha Kulkarni, School Teacher',
            feedback: "We organized a school picnic here for 30 students. The staff was helpful, and the educational tour on farm life and nature was very engaging. Value for money!",
            rating: 4,
        },
    ];




    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Day Picnic Spot Near Pune at Morachi Chincholi",
  "image": "https://morachichincholi.in/assets/images/one-day-picnic-spot-near-pune.jpg",
  "description": "Discover the perfect one day picnic spot near Pune at Morachi Chincholi. Enjoy outdoor activities, nature trails, pet-friendly areas, kids’ play zones, and a peaceful farm experience at Anand Krushi Paryatan Kendra.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2134"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "650",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/one-day-picnic-spot-near-pune"
  }
};



    return (
        <div>
<Helmet>
  <title>One Day Picnic Spot Near Pune at Morachi Chincholi | Anand Krushi Paryatan Kendra</title>
  <meta 
    name="description" 
    content="Plan a one day picnic near Pune at Morachi Chincholi. Explore family-friendly, nature-rich, and pet-friendly picnic spots with outdoor fun, kids’ play area, food stalls, and farm experience at Anand Krushi Paryatan Kendra." 
  />
  <meta 
    name="keywords" 
    content="Best picnic spots near Pune for one day, Morachi Chincholi picnic ideas, Family picnic spots near Pune, Romantic picnic destinations near Morachi Chincholi, Scenic day picnic near Pune, Budget-friendly picnic places near Morachi Chincholi, Picnic spots with outdoor activities near Pune, Pet-friendly picnic locations near Morachi Chincholi, Nature picnic spots near Pune, One day picnic with adventure near Morachi Chincholi, Popular picnic destinations near Pune for couples, Day picnic spots with farm experience near Morachi Chincholi, Peaceful picnic getaways near Pune, Picnic spots with kids’ play area near Morachi Chincholi, Weekend picnic destinations near Pune, Hidden picnic gems near Morachi Chincholi, Picnic spots with food stalls near Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/1.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onedaypicnicspot;